import { IFormField } from '@components-shared/forms/formField.interface';
import { keyMap } from '@locales/lokalise/keyMap';

export const COMMENT_FIELDS: IFormField[] = [
  {
    name: 'publicComment',
    title: keyMap.sharedFieldsPublicComment,
    type: 'textarea',
    attributes: { autoComplete: 'off' },
    limit: 256,
  },
  {
    name: 'internalComment',
    title: keyMap.sharedFieldsInternalComment,
    type: 'textarea',
    attributes: { autoComplete: 'off' },
    limit: 256,
  },
];

export const FOLLOW_UP_FIELDS = [
  {
    name: 'internalComment',
    title: keyMap.sharedFieldsInternalComment,
    type: 'textarea',
    attributes: { autoComplete: 'off' },
    limit: 256,
  },
];

export const COMMENT_FIELDS_UNLIM = [
  {
    name: 'publicComment',
    title: keyMap.sharedFieldsPublicComment,
    type: 'textarea',
    attributes: { autoComplete: 'off' },
  },
  {
    name: 'internalComment',
    title: keyMap.sharedFieldsInternalComment,
    type: 'textarea',
    attributes: { autoComplete: 'off' },
  },
];

export const FOLLOW_UP_FIELDS_UNLIM = [
  {
    name: 'internalComment',
    title: keyMap.sharedFieldsInternalComment,
    type: 'textarea',
    attributes: { autoComplete: 'off' },
  },
];

export default { COMMENT_FIELDS, FOLLOW_UP_FIELDS, COMMENT_FIELDS_UNLIM, FOLLOW_UP_FIELDS_UNLIM };
